// @flow
import * as React from 'react';
import { compose } from 'recompose';
import { withSvg } from './../../../components/Icon/withSvg';
import { GPath } from './../../../components/Icon/PathIcon';

const Icon = () => (
  <GPath fillRule="evenodd" stroke="none">
    <path
      d="M7.75 11.5L11.9929 15.7429C11.9968 15.7468 12.0032 15.7468 12.0071 15.7429L16.25 11.5"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="12" cy="15.75" r="0.75" fill="var(--color-mercari-blue)" />
    <path d="M12 15.5V3.75" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M2.75 16V20C2.75 20.1381 2.86193 20.25 3 20.25H21C21.1381 20.25 21.25 20.1381 21.25 20V16"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </GPath>
);

const SVG = compose(withSvg)(Icon);
export default ({
  viewBox = '0 0 24 24',
  width = '24',
  height = '24',
  ...props
}: any) => (
  <SVG
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    centerAlign={false}
    {...props}
  />
);
